<script lang="ts">
import { defineComponent, PropType, inject } from 'vue'
import StepWrapper from './StepWrapper.vue'

export default defineComponent({
  name: 'ProfessionStep',

  components: {
    StepWrapper,
  },

  props: {
    namespace: {
      type: String,
      required: true,
    },

    profession: {
      type: Object as PropType<InputText>,
      required: true,
    },
  },

  emits: ['update:profession', 'click:prev', 'click:next'],

  setup(_, { emit }) {
    const PROFESSIONS = inject<string[]>('PROFESSIONS')!

    const next = () => {
      emit('click:next')
    }

    return {
      // constants
      PROFESSIONS,

      // methods
      next,
    }
  },
})
</script>

<template>
  <StepWrapper
    :namespace="namespace"
    :input-scheme="profession"
    category-label="職種"
    :category-items="PROFESSIONS"
    @update:model-value="$emit('update:profession', $event)"
    @click:prev="$emit('click:prev')"
    @click:next="$emit('click:next')" />
</template>
